/**
 * 아이디·비밀번호 저장 + 자동 로그인 (로컬 편의용).
 *
 * 비밀번호는 base64 난독화만 됨(암호화 아님) — 사내 관제 PC·현장 모니터 보드
 * (부팅하면 무인으로 관제 화면이 떠야 하는 단말) 편의 기능이며, 공용 PC 에서는
 * 체크 해제 권장.
 *
 * 자동 로그인 규칙
 *   · 저장된 계정이 있으면 로그인 화면에 들어올 때 곧바로 로그인한다
 *     (앱 첫 실행, 리프레시 토큰 만료로 세션이 끊긴 뒤 모두).
 *   · 사용자가 직접 로그아웃한 뒤에는 **이번 실행에서는** 자동 로그인하지 않는다
 *     (sessionStorage 표시 — 앱을 다시 켜면 풀린다). 이게 없으면 로그아웃하는
 *     즉시 다시 로그인돼 로그아웃이 불가능해진다.
 */
const LOGIN_KEY = "eg.login.saved";
const MANUAL_LOGOUT_KEY = "eg.login.manualLogout";

export function loadSavedLogin(): { u: string; p: string } | null {
  try {
    const raw = localStorage.getItem(LOGIN_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as { u?: string; p?: string };
    return { u: o.u ?? "", p: o.p ? decodeURIComponent(escape(atob(o.p))) : "" };
  } catch {
    return null;
  }
}

export function saveLogin(u: string, p: string) {
  try {
    localStorage.setItem(LOGIN_KEY, JSON.stringify({ u, p: btoa(unescape(encodeURIComponent(p))) }));
  } catch {
    /* ignore */
  }
}

export function clearSavedLogin() {
  try {
    localStorage.removeItem(LOGIN_KEY);
  } catch {
    /* ignore */
  }
}

/** 사용자가 직접 로그아웃했다 — 이번 실행 동안 자동 로그인을 멈춘다. */
export function markManualLogout() {
  try {
    sessionStorage.setItem(MANUAL_LOGOUT_KEY, "1");
  } catch {
    /* ignore */
  }
}

/** 직접 로그인에 성공하면 로그아웃 표시를 지워 다음 만료 때 다시 자동 로그인한다. */
export function clearManualLogout() {
  try {
    sessionStorage.removeItem(MANUAL_LOGOUT_KEY);
  } catch {
    /* ignore */
  }
}

/** 지금 로그인 화면에서 저장된 계정으로 자동 로그인해야 하는가. */
export function shouldAutoLogin(): boolean {
  try {
    if (sessionStorage.getItem(MANUAL_LOGOUT_KEY)) return false;
  } catch {
    /* ignore */
  }
  const s = loadSavedLogin();
  return !!s && !!s.u.trim() && !!s.p;
}
